import DumbbellsIcon from "@assets/icons/dumbbells.svg";
import FireIcon from "@assets/icons/fire.svg";
import TemplatesIcon from "@assets/icons/templates.svg";
import TrophyIcon from "@assets/icons/trophy.svg";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { AppLogo } from "@ui/components/common/app-logo";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint, stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

interface ProjectDescriptionProps {
	showPhysioMeMonochromeLogo?: boolean;
}

export default function ProjectDescription({ showPhysioMeMonochromeLogo }: ProjectDescriptionProps): JSX.Element {
	const { format } = useI18n();

	return (
		<ContentRight>
			{showPhysioMeMonochromeLogo && <StyledAppLogo height={57} type="monochrome" />}
			<StyledSubTitle>{format("register.description.subTitle")}</StyledSubTitle>
			<NotesContainer>
				<StyledIcon>
					<DumbbellsIcon width={16} color={colors.mobilePrimaryBlue} />
				</StyledIcon>
				<div className="p-size-m">{format("login.description.v1_6.note1")}</div>
				<StyledIcon>
					<FireIcon width={16} color={colors.mobilePrimaryBlue} />
				</StyledIcon>
				<div className="p-size-m">{format("login.description.v1_6.note2")}</div>
				<StyledIcon>
					<TemplatesIcon width={16} color={colors.mobilePrimaryBlue} />
				</StyledIcon>
				<div className="p-size-m">{format("login.description.v1_6.note3")}</div>
				<StyledIcon>
					<TrophyIcon width={16} color={colors.mobilePrimaryBlue} />
				</StyledIcon>
				<div className="p-size-m">{format("login.description.v1_6.note4")}</div>
			</NotesContainer>
		</ContentRight>
	);
}

const ContentRight = styled.div`
	${stack(undefined, undefined, "flexstart")};
	flex: 1;
	color: ${colors.white};
	padding-top: 140px;

	@media ${physioMeTabletBreakpoint} {
		padding: 48px 32px;
	}
	@media ${physioMeMobileBreakpoint} {
		padding: 48px 16px;
	}
`;

const StyledAppLogo = styled(AppLogo)`
	color: ${colors.white};
	margin-bottom: 56px;
`;

const StyledSubTitle = styled.h2`
	font-size: 24px;
	margin-bottom: 32px;
`;

const NotesContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 16px;
	line-height: 32px;
`;

const StyledIcon = styled.div`
	background-color: ${colors.white};
	border-radius: 16px;
	padding: 8px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
